// Environment configuration utility
const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const VITE_API_PREFIX = import.meta.env.VITE_API_PREFIX;
const VITE_APP_NAME = import.meta.env.VITE_APP_NAME;
const VITE_APP_VERSION = import.meta.env.VITE_APP_VERSION;

export const config = {
  API_BASE_URL: VITE_API_BASE_URL,
  API_PREFIX: VITE_API_PREFIX,
  APP_NAME: VITE_APP_NAME,
  APP_VERSION: VITE_APP_VERSION,
  ENV: import.meta.env.MODE || 'development'
};

// API endpoints
export const API_ENDPOINTS = {
  // Contact messages endpoint
  CONTACT_MESSAGES: `${config.ADMIN_BASE}/contact-us/messages/`,
  BASE_URL: `${config.API_BASE_URL}${config.API_PREFIX}`,
  VERIFY_LOGIN_OTP: `${config.API_BASE_URL}${config.API_PREFIX}/verify-login-otp/`,
  SEND_LOGIN_OTP: `${config.API_BASE_URL}${config.API_PREFIX}/login/`,
  SEND_REGISTER_OTP: `${config.API_BASE_URL}${config.API_PREFIX}/register/`,
  VERIFY_REGISTER_OTP: `${config.API_BASE_URL}${config.API_PREFIX}/verify-otp/`,
  CHANGE_MODE: `${config.API_BASE_URL}${config.API_PREFIX}/change_mode`,

  // Admin endpoints
  ADMIN_BASE: `${config.API_BASE_URL}${config.API_PREFIX}/api/v1/admin`,
  DELIVERY_ADMIN_BASE: `${config.API_BASE_URL}${config.API_PREFIX}/delivery-partner/api/v1/admin`,
  CAMPUSLIFE_ADMIN_BASE: `${config.API_BASE_URL}${config.API_PREFIX}/campuslife/admin`,

  // Common endpoints
  DASHBOARD_SUMMARY: `${config.API_BASE_URL}${config.API_PREFIX}/api/v1/admin/dashboard/summary/`,
  DASHBOARD_LATEST: `${config.API_BASE_URL}${config.API_PREFIX}/api/v1/admin/dashboard/latest/`,
  DELIVERY_ORDERS: `${config.API_BASE_URL}${config.API_PREFIX}/delivery-partner/display-took-orders/`,
  DELIVERY_ORDERS_IN_PROGRESS: `${config.API_BASE_URL}${config.API_PREFIX}/delivery-partner/delivery-orders-in-progress/`,
  SNAP_TO_ROADS: `${config.API_BASE_URL}${config.API_PREFIX}/delivery-partner/snap-to-roads/`,

  // Porter Service - registered vendor/business list (Order Routing > Assign to a Vendor)
  PORTER_BUSINESS_DETAILS: `${config.API_BASE_URL}${config.API_PREFIX}/porter/business/details/`,

  // Porter Service - a vendor's own delivery partners (Order Routing > Assign to a Vendor > View Details)
  PORTER_BUSINESS_DELIVERY_PARTNERS: `${config.API_BASE_URL}${config.API_PREFIX}/porter/business/delivery-partners/`,

  // Porter Service - assign an order to a vendor business (Order Routing > Assign to a Vendor > Assign Vendor)
  PORTER_ASSIGN_VENDOR: `${config.API_BASE_URL}${config.API_PREFIX}/porter/business/update-businessid/`,

  // Porter Service - completed orders list (Order Routing > Completed tab)
  PORTER_COMPLETED_ORDERS: `${config.API_BASE_URL}${config.API_PREFIX}/porter/business/completed-orders/`,

  // Porter Service - assign a rider/delivery partner to an order (Order Routing > Assign Order)
  PORTER_ASSIGN_RIDER: `${config.API_BASE_URL}${config.API_PREFIX}/porter/business/assign-rider/`,

  // Porter Service - reassign an order's delivery partner to a different rider
  // (Order Routing > Assign Order, when the order already has a rider)
  PORTER_REASSIGN_RIDER: `${config.API_BASE_URL}${config.API_PREFIX}/porter/business/reassign-rider/`
};
